var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-documentos-relacionados-obra"}},[_c('documentos-relacionados',{attrs:{"idReferencia":_vm.idObra,"moduloOrigen":"planeacion","datos":_vm.getObra}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }